// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__36Phg","buttons":"RemoveExpirationActionButtons_buttons__3nxGH"};